import { useEffect, useState } from 'react';
import styles from '../css/ImageForm.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react';
import { photofolioSelector,updateImageInAlbum } from '../redux/reducers/reducers';

export function UpdateImageForm() {
    const [imageObj, setImageOBJ] = useState({ text: "", url: "", index: null });

    const {currImgCardUpdate} = useSelector(photofolioSelector);

    const inputRef = useRef(null);
    const dispatch = useDispatch();

    const onClear = () => {
        setImageOBJ({ text: "", url: "", index: null });
    };

    const submitUpdateHandle = (e) => {
        e.preventDefault();
        dispatch(updateImageInAlbum(imageObj));
        onClear();
    };

    useEffect(() => {
        console.log("currImgCardUpdate from updateImageForm component ",currImgCardUpdate)
        inputRef.current.focus();
        
        setImageOBJ({ text: currImgCardUpdate.text, url: currImgCardUpdate.url, index: currImgCardUpdate.index });
    }, [currImgCardUpdate]);

    return (
        <div className={styles.container}>
            <span>Update image {currImgCardUpdate.text}</span>

            <form>
                <input
                    type="text"
                    placeholder="Title"
                    required
                    onChange={(e) => setImageOBJ({ ...imageObj, text: e.target.value })}
                    value={imageObj.text}
                    ref={inputRef}
                />
                <input
                    type="text"
                    placeholder="Image Url"
                    required
                    onChange={(e) => setImageOBJ({ ...imageObj, url: e.target.value })}
                    value={imageObj.url}
                />

                <div className={styles.footer}>
                    <button type="button" id={styles.clear} onClick={onClear}>
                        Clear
                    </button>
                    <button id={styles.add} onClick={submitUpdateHandle}>
                        Update
                    </button>
                </div>
            </form>
        </div>
    );
}
